var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 27.9993V13.9993C36.7493 13.3856 36.5874 12.7828 36.2801 12.2514C35.973 11.72 35.5315 11.2787 35 10.9718L22.75 3.97184C22.218 3.66466 21.6144 3.50293 21 3.50293C20.3856 3.50293 19.782 3.66466 19.25 3.97184L7 10.9718C6.46846 11.2787 6.02697 11.72 5.71981 12.2514C5.41265 12.7828 5.25063 13.3856 5.25 13.9993V27.9993C5.25063 28.6131 5.41265 29.2159 5.71981 29.7472C6.02697 30.2787 6.46846 30.7199 7 31.0268L19.25 38.0268C19.782 38.334 20.3856 38.4958 21 38.4958C21.6144 38.4958 22.218 38.334 22.75 38.0268L35 31.0268C35.5315 30.7199 35.973 30.2787 36.2801 29.7472C36.5874 29.2159 36.7493 28.6131 36.75 27.9993Z",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72266 12.1797L21.0001 21.0173L36.2776 12.1797",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 38.64V21",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel);
export default __webpack_public_path__ + "static/media/model.e3d902ea09178c49b0216725a0f67107.svg";
export { ForwardRef as ReactComponent };